import { Center, AspectRatio, Box, Text, Flex, Icon, Button } from '@chakra-ui/react';
import NextImage from 'next/image';
import NextLink from 'next/link';
import { FC } from 'react';

import IcBusiness from '@/assets/icons/ic-business.svg';
import IcCamera from '@/assets/icons/ic-camera.svg';
import IcGlobe from '@/assets/icons/ic-globe.svg';
import CameraIcon from '@/assets/icons/ic-photo-camera.svg';
import TripleRBackgroundImage from '@/assets/images/publishers/bg-triple-r.png';
import thumbDigitalArchive from '@/assets/images/publishers/trippler-section/digital-archive.png';
import thumbGlobalInclusivity from '@/assets/images/publishers/trippler-section/global-inclusivity.png';
import thumbRevenueStream from '@/assets/images/publishers/trippler-section/revenue-stream.png';

import { ThumbnailIconCard } from '@/components/ui/features/publishers/TripleRSection/components/ThumbnailIconCard';

export const TripleRSection: FC = () => {
  return (
    <Center bgColor="white" position="relative">
      <AspectRatio
        objectFit="cover"
        minH={{ base: '1030px', md: '1054px', lg: '804px' }}
        h="full"
        w="full"
        ratio={1905 / 530}
      >
        <NextImage
          objectPosition="center"
          quality={90}
          layout="fill"
          priority={true}
          src={TripleRBackgroundImage}
          alt="Hero cover"
        />
      </AspectRatio>
      <Flex
        minH={{ base: '1030px', md: '1054px', lg: '804px' }}
        h="full"
        px={5}
        top={0}
        textAlign="center"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        position="absolute"
        w="full"
      >
        <Text fontFamily="heading" fontWeight="bold" maxW="790px" fontSize={{ base: '2xl', md: '4xl', lg: '5xl' }}>
          Resilience, Reach, and Revenue.
          <br />
          <Text
            as="span"
            fontFamily="heading"
            backgroundClip="text"
            bgGradient="linear-gradient(90deg, #E179F1 0%, #BD8AF5 26.56%, #70B5EF 50%, #5BC5DF 74.48%, #52A3B0 98.96%)"
          >
            Effortlessly.
          </Text>
        </Text>
        <Text mt={{ base: 4, md: 6, lg: 8 }} fontSize={{ base: 'lg', lg: 'xl' }} maxW="1000px">
          We provide a complete, surprisingly affordable package designed specifically for academic societies.
        </Text>
        <Flex
          flexWrap={{ base: 'wrap', lg: 'nowrap' }}
          justifyContent="center"
          flexDirection={{ base: 'column', lg: 'row' }}
          mt={{ base: 4, md: 8, lg: 10 }}
          w="100%"
          gap={4}
        >
          <ThumbnailIconCard
            label="Build a Citable Digital Archive"
            text="We professionally record every presentation, creating a permanent, citable library of your proceedings that enhances your society's prestige for years to come."
            thumbnail_url={thumbDigitalArchive}
            icon={<Icon w="20px" h="18px" color="violet.500" as={IcBusiness} />}
          />
          <ThumbnailIconCard
            label="Achieve True Global Inclusivity"
            text="Offer a seamless virtual attendance option for those who cannot travel. Ensure the best minds can participate, present, and collaborate."
            thumbnail_url={thumbGlobalInclusivity}
            icon={<Icon w="20px" h="18px" color="violet.500" as={IcGlobe} />}
          />
          <ThumbnailIconCard
            label="Unlock a New Revenue Stream"
            text="Implement a secure paywall for virtual access and on-demand content, turning a potential loss into sustainable income."
            thumbnail_url={thumbRevenueStream}
            icon={<Icon w="24px" h="22px" color="violet.500" as={IcCamera} />}
          />
        </Flex>

        <NextLink href="/contact-us/conferences">
          <Button
            type="button"
            size={{ base: 'sm', lg: 'lg' }}
            leftIcon={<CameraIcon width="24px" />}
            mt={{ base: 4, sm: 6, lg: 8 }}
          >
            See a demo
          </Button>
        </NextLink>
      </Flex>
    </Center>
  );
};
